import React, { useMemo, useState, useCallback, memo, useEffect, useRef, useLayoutEffect } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { pushMenuItemsByScreenId } from '@reducers/orders';
import { TouchableButton } from '@components/common/Touchable/index';
import style from './AppSidebarGroups.module.scss';
const AppSidebarGroups = ({
  menusList,
  menuIndex,
  pushMenuItemsByScreenId,
  selectedMenuGroupId,
  serverAppTheme,
}) => {
  const [selectedOption, setSelectedOption] = useState({});
  const defaultMenu = useMemo(() => menusList[menuIndex] || {}, [
    menusList,
    menuIndex,
  ]);
  const defaultScreens = useMemo(() => {
    const screens =
      defaultMenu.screens?.filter(
        screen => screen.menuItemLinks.length !== 0
      ) || [];
    // if (isDriveThru) {
    //   return screens.filter(
    //     screen => !(screen.condiment === 1 && screen.name === 'Condiments')
    //   );
    // }
    setSelectedOption(screens);
    return screens;
  }, [defaultMenu]);
  useEffect(() => {
    if (!selectedMenuGroupId) {
      const firstScreen = defaultScreens[0];
      if (firstScreen) {
        setSelectedOption(firstScreen);
        pushMenuItemsByScreenId(firstScreen.id);
      }
      return;
    }
    const matchedOption = defaultScreens.find(
      menu => menu.id === selectedMenuGroupId
    );
    if (matchedOption) {
      setSelectedOption(matchedOption);
    } else {
      const firstScreen = defaultScreens[0];
      if (firstScreen) {
        setSelectedOption(firstScreen);
        pushMenuItemsByScreenId(firstScreen.id);
      }
    }
  }, []);
  const menuContainerRef = useRef(null);
  useLayoutEffect(() => {
    const savedScroll = sessionStorage.getItem('menuScrollTop') || 0;
    if (menuContainerRef.current && savedScroll !== null) {
      menuContainerRef.current.scrollTop = Number(savedScroll);
    }
  }, []);
  const handleScroll = (e) => {
    window.sessionStorage.setItem('menuScrollTop', e.target.scrollTop);
  };

  const buttonSelected = useCallback(
    (optionId, index) => {
      const selectedOption = defaultScreens.find(menu => menu.id === optionId);
      window.sessionStorage.setItem('menuName', selectedOption.name);
      window.sessionStorage.setItem('menuTypeId', selectedOption.id);
      window.sessionStorage.setItem('colorCode', index);
      window.sessionStorage.setItem(
        'menuScreenButtonColor',
        selectedOption.menuScreenButtonColor
      );
      setSelectedOption(selectedOption);
      pushMenuItemsByScreenId(selectedOption.id);
      // onSearchChange('');
    },
    [pushMenuItemsByScreenId, defaultScreens]
  );
  return (
    <div
      className="row mt-1"
      style={{ minHeight: 0, width: '142px', overflowX: 'hidden', overflowY: 'auto' }}
      ref={menuContainerRef}
      onScroll={handleScroll}
    >
      {defaultScreens.map((category, index) => {
        const isSelected = selectedOption.id === category.id;
        return (
          <GroupButtonMemo
            key={category.name + '-' + category.id}
            isSelected={isSelected}
            index={index}
            isOptionSelected={!selectedOption.name}
            categoryName={category.name}
            buttonSelected={buttonSelected}
            categoryId={category.id}
            backgroundColor={category?.menuScreenButtonColor || (isSelected ? serverAppTheme?.orders_selected_category : serverAppTheme?.orders_Unselected_category)}
          />
        );
      })}
    </div>
  );
};

const GroupButton = ({
  isSelected,
  index,
  isOptionSelected,
  categoryName,
  buttonSelected,
  categoryId,
  backgroundColor,
}) => {
  return (
    <TouchableButton
      style={{
        backgroundColor,
        color: 'rgb(0, 0, 0)',
        border:
          isSelected || (isOptionSelected && index === 0)
            ? '2px solid rgb(121, 116, 126)'
            : 'none',
        'text-align': 'left',
      }}
      className={cn(style.dtcategory, style.selectedsubItem)}
      onClick={e => {
        e.preventDefault();
        buttonSelected(categoryId, index);
      }}
    >
      {categoryName}
    </TouchableButton>
  );
};
const GroupButtonMemo = memo(GroupButton);

const mapStateToProps = ({ orders, theme }) => ({
  check: orders.seats,
  serverAppTheme: theme.serverAppTheme,
  menuIndex: orders.menuIndex,
  menusList: orders.menusList,
  selectedMenuGroupId: orders.selectedMenuGroupId,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ pushMenuItemsByScreenId }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(memo(AppSidebarGroups));
